import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "canvas-core-react/lib/CanvasStyles.css";
import "./index.scss";
import {makeServer} from "./server";
import CONFIG from "./config";

const Api = CONFIG.API;

if (Api.MockServer) {
    makeServer({environment: "development"});
}
ReactDOM.render(
    <App></App>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
